<template>
  <div class="home">
    <div class="content-container">
      <projects></projects>
      <information></information>
    </div>
  </div>
</template>

<script>
import Information from './Information.vue'
import Projects from './Projects.vue'

export default {
  name: 'home',
  components: {
    'information': Information,
    'projects': Projects
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
@import '../assets/styles/base';

.home {

}
</style>



// WEBPACK FOOTER //
// client/components/Home.vue